import { c as _c } from "react/compiler-runtime";
import type { BackupStatus } from '@repo/api-gw-sdk';
import React from 'react';
import { ResourceStatusIcon } from '@/components/resourceStatus/resourceStatusBadge';
import { BackupStatuses } from '@/data/inventory/data';
export const BackupStatusIcon = React.forwardRef((t0, ref) => {
  const $ = _c(9);
  let backupStatus;
  let props;
  if ($[0] !== t0) {
    ({
      backupStatus,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backupStatus;
    $[2] = props;
  } else {
    backupStatus = $[1];
    props = $[2];
  }
  const data = BackupStatuses[backupStatus];
  if (!data) {
    return null;
  }
  let t1;
  if ($[3] !== data.backgroundColor || $[4] !== data.icon || $[5] !== data.iconColor || $[6] !== props || $[7] !== ref) {
    t1 = <ResourceStatusIcon ref={ref} {...props} icon={data.icon} iconColor={data.iconColor} backgroundColor={data.backgroundColor} />;
    $[3] = data.backgroundColor;
    $[4] = data.icon;
    $[5] = data.iconColor;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});